import { combineReducers } from "redux";

import exportFile from "./exportFile";

export default combineReducers({ exportFile });
